import Citizenship, { CitizenshipSections } from './Citizenship';

export default Citizenship;
export { CitizenshipSections };
